import type { components } from "@/shared/api";

type HeroLine = components["schemas"]["FriendHeroOut"];

export type CommonHero = { heroId: number; me: HeroLine; them: HeroLine };

// Сколько общих героев показываем в сравнении.
export const COMMON_HEROES_LIMIT = 3;

// Герои, на которых за период играли оба: больше матчей на двоих — выше.
export const commonHeroes = (
  mine: readonly HeroLine[],
  theirs: readonly HeroLine[],
): CommonHero[] => {
  const byHero = new Map(theirs.map((line) => [line.hero_id, line]));
  return mine
    .flatMap((me) => {
      const them = byHero.get(me.hero_id);
      return them === undefined ? [] : [{ heroId: me.hero_id, me, them }];
    })
    .sort((a, b) => b.me.matches + b.them.matches - (a.me.matches + a.them.matches))
    .slice(0, COMMON_HEROES_LIMIT);
};
